import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import { contactInfo, footerServices, quickLinks } from '../data';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            {/* Company Info */}
            <div>
              <img
                src="/images/logo/footer-white.png"
                alt="Aashi Constructions"
                loading="lazy"
                className="h-10 sm:h-12 w-auto mb-4"
              />
              <p className="text-sm leading-relaxed mb-6">
                High-quality construction services with premium materials and expert craftsmanship for over 10 years across Karnataka.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/profile.php?id=61552791961512" className="hover:text-brand-600 transition-colors duration-300">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href="https://www.instagram.com/aashiconstructions" className="hover:text-brand-600 transition-colors duration-300">
                  <Instagram className="w-5 h-5" />
                </a>
                <a href="https://youtube.com/@AashiGroups?si=APW2pekclUpdV8Ph" className="hover:text-brand-600 transition-colors duration-300">
                  <Youtube className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link, i) => (
                  <li key={i}>
                    <Link to={link.path} onClick={() => window.scrollTo(0, 0)} className="hover:text-brand-600 transition-colors duration-300 text-sm">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-white font-semibold mb-4">Our Services</h4>
              <ul className="space-y-3 text-sm">
                {footerServices.map((service, index) => (
                  <li key={index}>
                    <Link to="/services" onClick={() => window.scrollTo(0, 0)} className="hover:text-brand-600 transition-colors duration-300 cursor-pointer">
                      {service}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-white font-semibold mb-4">Get In Touch</h4>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-brand-600 flex-shrink-0 mt-1" />
                  <span className="text-sm">{contactInfo.address}</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-brand-600 flex-shrink-0 mt-1" />
                  <div className="flex flex-col">
                    {contactInfo.phones.map((phone, i) => (
                      <a key={i} href={`tel:${phone.replace(/\s/g, '')}`} className="text-sm hover:text-brand-600 transition-colors duration-300">
                        {phone}
                      </a>
                    ))}
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-brand-600 flex-shrink-0 mt-0.5" />
                  <div className="flex flex-col">
                    {contactInfo.emails.map((email, i) => (
                      <a key={i} href={`mailto:${email}`} className="text-sm hover:text-brand-600 transition-colors duration-300">
                        {email}
                      </a>
                    ))}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {/* Bottom Bar */}
          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-xs sm:text-sm leading-relaxed">
              &copy; {new Date().getFullYear()} Aashi Constructions. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
